import React from 'react';
import { Footer } from '../components/Footer';
export function ContactUs() {
  return <div className="w-full bg-white" data-id="element-1235">
      <section className="w-full py-24 sm:py-28" data-id="element-1236">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1237">
          <div data-id="element-1238">
            <h1 className="text-[3.5rem] font-bold text-carbon-deep tracking-tight leading-[1.1]" data-id="element-1239">
              Hi<span className="text-carbon-bright" data-id="element-1240">.</span> How can we help<span className="text-carbon-bright" data-id="element-1241">?</span>
            </h1>
            <p className="mt-4 text-base sm:text-lg text-carbon-deep/70 max-w-2xl" data-id="element-1242">
              Please use the form below to send us a message, request an
              evaluation, or schedule a demo, and we&apos;ll get back to you as
              soon as we can.
            </p>
          </div>

          <div className="mt-10" data-id="element-1243">
            {/* Change or deletion of the name attributes in the input tag will lead to empty values on record submission */}
            <form action="https://forms.zohopublic.com/zanto1/form/TrialRequest/formperma/qRsYidEXZlz-mvq65UCXEkEbxDY0UQwpdjXzj8lKTWE/htmlRecords/submit" name="form" id="form" method="POST" acceptCharset="UTF-8" encType="multipart/form-data" className="space-y-4" data-id="element-1244">
              <input type="hidden" name="zf_referrer_name" value="" data-id="element-1245" />
              <input type="hidden" name="zf_redirect_url" value="/contact-thanks" data-id="element-1246" />
              <input type="hidden" name="zc_gad" value="" data-id="element-1247" />

              <h2 className="text-lg font-semibold text-carbon-deep" data-id="element-1248">Trial Request</h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1249">
                <input type="text" maxLength={255} name="Name_First" fieldType="7" placeholder="First Name" className="w-full rounded-lg border border-[#9aa6af] px-4 py-3 text-sm text-carbon-deep focus:outline-none focus:border-carbon-bright" data-id="element-1250" />
                <input type="text" maxLength={255} name="Name_Last" fieldType="7" placeholder="Last Name" className="w-full rounded-lg border border-[#9aa6af] px-4 py-3 text-sm text-carbon-deep focus:outline-none focus:border-carbon-bright" data-id="element-1251" />
              </div>

              <input type="text" maxLength={255} name="Email" fieldType="9" placeholder="Email" className="w-full rounded-lg border border-[#9aa6af] px-4 py-3 text-sm text-carbon-deep focus:outline-none focus:border-carbon-bright" data-id="element-1252" />

              <input type="text" name="SingleLine" fieldType="1" maxLength={255} placeholder="Company Name" className="w-full rounded-lg border border-[#9aa6af] px-4 py-3 text-sm text-carbon-deep focus:outline-none focus:border-carbon-bright" data-id="element-1253" />

              <div className="rounded-lg border border-[#9aa6af] p-4" data-id="element-1254">
                <p className="text-sm text-carbon-deep/70" data-id="element-1255">
                  Your terms and conditions go here...
                </p>
                <label className="mt-4 flex items-center gap-2 text-sm text-carbon-deep" data-id="element-1256">
                  <input className="h-4 w-4" name="TermsConditions" type="checkbox" data-id="element-1257" />
                  <span data-id="element-1258">I accept the Terms and Conditions.</span>
                </label>
              </div>

              <button type="submit" className="inline-flex items-center justify-center rounded-lg bg-[#6bcb78] px-10 py-3 text-sm font-semibold text-white hover:bg-carbon-light transition-colors" data-id="element-1259">
                Submit
              </button>
            </form>
          </div>

          <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 gap-10" data-id="element-1260">
            <div data-id="element-1261">
              <p className="text-xl font-semibold text-carbon-deep" data-id="element-1262">CarbonSafe HQ</p>
              <div className="mt-3 space-y-1 text-sm text-carbon-deep/70" data-id="element-1263">
                <p data-id="element-1264">Serena Heights Kigo</p>
                <p data-id="element-1265">Kampala, Uganda</p>
              </div>
            </div>
            <div data-id="element-1266">
              <p className="text-xl font-semibold text-carbon-deep" data-id="element-1267">CarbonSafe Operations</p>
              <div className="mt-3 space-y-1 text-sm text-carbon-deep/70" data-id="element-1268">
                <p data-id="element-1269">+256 776 007755</p>
                <p data-id="element-1270">+256 774 217716</p>
                <p data-id="element-1271">operations@carbonsafe.earth</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1272" />
    </div>;
}